import { type IconProps, getIconProps } from '#types';

/**
 * Hamburger menu icon (three horizontal lines)
 * Used to open navigation menus on mobile
 */
export function HamburgerIcon({ ariaHidden = true, className = 'h-6 w-6', strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg
      {...getIconProps({ ariaHidden, className, ...props })}
      stroke="currentColor"
      strokeWidth={strokeWidth}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  );
}
